import { SystemLabel } from './system-label';

export class SaleSystemLabel extends SystemLabel {
  getSortOrderTitle(): string {
    return 'Sale';
  }

  public getSaleText(): string {
    return this.text || 'SALE';
  }
}
